import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useUserSettings } from "../../context/userSettingsContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminMileagesApi } from "../../http/mileages/api";
import { UpsertMileage } from "../../http/mileages/types";
import { convertMilesToKilometers } from "../../types/utils";
import ModalDialog from "../ui/ModalDialog";
import MileageForm, { MileageFormBody } from "./MileageForm";

interface CreateMileageDialogProps {
  carId?: string;
  onClose: (success?: boolean) => void;
}

const CreateMileageDialog: FC<CreateMileageDialogProps> = ({ carId, onClose }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const mileagesApi = useAdminMileagesApi();

  const onSubmit = async (formData: MileageFormBody) => {
    const body: UpsertMileage = {
      carId: carId ?? formData.car?.id!,
      date: formData.date,
      distance: !!userSettings.me.distanceInMiles ? convertMilesToKilometers(formData.distance!) : formData.distance!,
    };

    setIsSubmitting(true);
    try {
      await mileagesApi.insertMileage(body);
      dispatch(showSuccessNotification(i18n.t));
      onClose(true);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog onClose={onClose} title={i18n.t.mileages.new}>
      <MileageForm isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} />
    </ModalDialog>
  );
};

export default CreateMileageDialog;
